import React from "react";
import MeterTitle from "./MeterTitle";
import RealizedTypeMeterContainer from "./RealizedTypeMeterContainer";
import ValueTypeMeterContainer from "./ValueTypeMeterContainer";

const MeterContainer = React.forwardRef(
  ({ meter, reportId, index, modifyMeter, disabled }, meterRef) => {
    return (
      <div className="border-bottom">
        <MeterTitle meter={meter} index={index} />

        {meter.meterValueType === "REALIZED" && (
          <RealizedTypeMeterContainer
            ref={meterRef}
            meter={meter}
            index={index}
            modifyMeter={modifyMeter}
            reportId={reportId}
            disabled={disabled}
          />
        )}

        {meter.meterValueType === "NUMBER" && (
          <ValueTypeMeterContainer
            ref={meterRef}
            meter={meter}
            index={index}
            modifyMeter={modifyMeter}
            disabled={disabled}
          />
        )}
      </div>
    );
  }
);

export default MeterContainer;



// WEBPACK FOOTER //
// ./src/components/profile/reports/components/MeterContainer.jsx